import each from "lodash/each";
import trim from "lodash/trim";
import parseQueryString from "../utils/ParseQueryString";

class BrochureCarSelect {
  private classNameRoot = "dabCarSelect";
  scope: Element = null;
  private isMultiSelect: boolean = false;
  autoSelected: boolean = false;
  selectedCars: any[] = [];
  originalParams: string;

  private immedate: boolean = false;

  constructor(multiSelect: boolean = false, immediateSelect: boolean = false) {
    this.scope = document.querySelector(`.${this.classNameRoot}`);
    if (!this.scope) return;

    this.immedate = immediateSelect;
    this.isMultiSelect = multiSelect;
    this.parseOriginalParams();
    this.attachEvents();
    this.autoSelect();
  }

  private getModelSlug(modelName: string): string {
    const name = (modelName || "").toLowerCase();
    if (name === "all-new outback") return "outback2026";
    if (name === "all-new outback wilderness") return "wilderness2026";
    return name;
  }

  private parseOriginalParams() {
    const queryStr = parseQueryString();
    let newQueryStr = "";
    Object.keys(queryStr).map(function (keyName, keyIndex) {
      if (keyName !== "model") {
        newQueryStr += `&${keyName}=${queryStr[keyName]}`;
      }
    });
    this.originalParams = newQueryStr;
  }

  private attachEvents(): void {
    //Car Clicks
    each(
      this.scope.querySelectorAll(`.${this.classNameRoot}__item`),
      (carItem: Element): void => {
        carItem.addEventListener("click", () =>
          this.selectItem(carItem, this.immedate)
        );
      }
    );
  }

  private updateUrl() {
    history.replaceState(
      null,
      null,
      this.selectedCars.length
        ? `?model=${this.selectedCars
            .map((item) => this.getModelSlug(item.modelName))
            .join(",")}${this.originalParams}`
        : `?${this.originalParams}`
    );
  }

  isBookTestPage() {
    return document.location.pathname === "/book-test-drive";
  }

  selectItem(
    carItem,
    immediate: boolean = false,
    triggerReload: boolean = false,
    callback: Function = function () {}
  ): void {
    const modelName: string = carItem.getAttribute("data-modelName");
    if (!modelName) return;

    const isSelected: boolean =
      this.selectedCars.filter((i) => i.modelName === modelName).length > 0;

    if (!this.isMultiSelect && this.selectedCars.length) return;

    if (isSelected) {
      return this.deselectItem(carItem, modelName);
    }
    if (this.selectedCars.length >= 3) return;

    window["pushDigitalData"](
      {
        event: "model_selected",
        selected_model: modelName,
      },
      true
    );

    this.selectedCars.push({ modelName, carItem });

    carItem.classList.add(`${this.classNameRoot}__item--selected`);
    this.setCheckboxChecked(carItem, true);
    this.scope.classList.add(`${this.classNameRoot}--selected`);

    this.updateUrl();
    triggerReload && location.reload();

    setTimeout(
      () => this.onSelectionComplete(this.selectedCars),
      immediate ? 0 : 1500
    );
  }

  deselectItem(carItem, modelName): void {
    let index = -1;

    this.selectedCars.forEach((c, i) => {
      if (c.modelName === modelName) index = i;
    });

    if (index !== -1) {
      this.selectedCars.splice(index, 1);
    }

    carItem.classList.remove(`${this.classNameRoot}__item--selected`);
    this.setCheckboxChecked(carItem, false);

    if (this.selectedCars.length < 1) {
      this.scope.classList.remove(`${this.classNameRoot}--selected`);
    }
    this.updateUrl();
    setTimeout(() => this.onDeselectionComplete(this.selectedCars), 0);

    window["pushDigitalData"](
      {
        event: "model_deselected",
        selected_model: modelName,
      },
      true
    );
  }

  private autoSelect(): void {
    const query = parseQueryString();
    let selected: number = 0;
    let modelsQuery =
      typeof query.model === "undefined"
        ? ""
        : decodeURI(query.model.toLowerCase());

    let models = modelsQuery
      .replace("wrx or wrx sti", "wrx,wrx sti")
      .replace("wrx and wrx sti", "wrx,wrx sti")
      .split(",")
      .map((item) => trim(item))
      .filter((item) => !!item);

    if (models.length < 1) return;

    if (models.length > 3) models = models.slice(0, 3);

    if (!this.isMultiSelect) models = [models[0]];

    const carItems = this.scope.querySelectorAll(
      `.${this.classNameRoot}__item`
    );
    each(carItems, (carItem) => {
      const model = carItem.getAttribute("data-modelName");
      if (!model) return;
      const index = models.indexOf(this.getModelSlug(model));

      if (index < 0) return;
      if (this.selectedCars.some((c) => c.modelName === model)) return;

      selected++;
      this.selectItem(carItem, true, false);
    });

    if (selected) this.autoSelected = true;
  }

  private setCheckboxChecked(carItem: Element, checked: boolean): void {
    const checkbox = carItem.querySelector<HTMLInputElement>(
      `.${this.classNameRoot}__checkboxInput`
    );
    if (checkbox) checkbox.checked = checked;
  }

  onDeselectionComplete(selectedCars): void {}

  onSelectionComplete(selectedCars): void {}

  reset(): void {
    this.selectedCars = [];

    each(
      this.scope.querySelectorAll(`.${this.classNameRoot}__item`),
      (carItem: Element): void => {
        carItem.classList.remove(`${this.classNameRoot}__item--selected`);
        this.setCheckboxChecked(carItem, false);
      }
    );

    this.scope.classList.remove(`${this.classNameRoot}--selected`);
  }
}

export default BrochureCarSelect;
